export function i18nKey<T extends string>(key: T): T {
  return key
}
